import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import { t } from 'ember-intl';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import type {
  AssetFolder,
  SetAssetFolder,
  ValidateAssetUpload,
} from '../types';
import Folder from './folder';
import styles from './styles.module.css';

const bem = getBem(styles);

interface FoldersSignature {
  Args: {
    allowedFolder?: string;
    folders: AssetFolder[];
    onValidateUpload?: ValidateAssetUpload;
    selectedFolderId?: string;
    setFolder: SetAssetFolder;
  };
  Element: HTMLUListElement;
}

<template>
  <ul class={{(bem)}}>
    <Folder
      @allowedFolder={{@allowedFolder}}
      @folder={{hash value=undefined label=(t 'asset_folders.all_assets')}}
      @selectedFolderId={{@selectedFolderId}}
      @setFolder={{@setFolder}}
      data-test-all-assets
    />

    {{#each @folders as |folder|}}
      <Folder
        @allowedFolder={{@allowedFolder}}
        @folder={{folder}}
        @selectedFolderId={{@selectedFolderId}}
        @setFolder={{@setFolder}}
        @onValidateUpload={{@onValidateUpload}}
      />
    {{/each}}
  </ul>
</template> satisfies TOC<FoldersSignature>;
